import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModeloPrestamoMS } from 'src/app/open-api';

@Component({
  selector: 'app-prestamo-detalle',
  templateUrl: './prestamo-detalle.component.html',
  styleUrls: ['./prestamo-detalle.component.scss']
})
export class PrestamoDetalleComponent implements OnInit {

  @Input() prestamo?: ModeloPrestamoMS;

  constructor(
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

}
